/* v23 Homepage Fixes — Tara Sartoria */
(function() {
  function init() {
    try {
      /* FIX 1: Hero banner clickable — link to /collections/best-sellers */
      var heroSection = document.getElementById('shopify-section-image_banner');
      if (heroSection) {
        heroSection.addEventListener('click', function(e) {
          if (e.target.closest('a, button')) return;
          window.location.href = '/collections/best-sellers';
        });
      }

      /* FIX 3: Clickable multicolumn images — click image to follow card link */
      var multiSections = ['multicolumn_Umx3w8', 'multicolumn_ar8JwT', 'multicolumn_eCnM3N'];
      multiSections.forEach(function(id) {
        var sec = document.getElementById('shopify-section-' + id);
        if (!sec) return;
        sec.querySelectorAll('.multicolumn-card').forEach(function(card) {
          var link = card.querySelector('a[href]');
          var img = card.querySelector('.multicolumn-card__image-wrapper');
          if (!link || !img) return;
          var href = link.getAttribute('href');
          img.addEventListener('click', function() {
            window.location.href = href;
          });
        });
      });
    } catch (err) {
      console.error('v23 homepage fixes error:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
